import { CommandGroup } from '../types/command.types';

/** Represents the prefix for the command pubSub event names. */
export const commandPubSubEventNamePrefix = 'command:' as const;

/** Represents the delimiter between group and command name. */
export const commandGroupDelimiter = ':' as const;

/** Represents the internal command groups. */
export const commandGroups = [
  'app',
  'conversation',
  'search',
  'richTextEditor',
] as const;

/** Represents the attributes of the command groups. */
export const commandGroupAttributes: Readonly<
  Record<
    CommandGroup,
    {
      readonly label: string;
    }
  >
> = {
  app: {
    label: 'Global commands',
  },
  conversation: {
    label: 'Conversation',
  },
  search: {
    label: 'Search',
  },
  richTextEditor: {
    label: 'Text editor',
  },
};
